import { render, staticRenderFns } from "./_manage-system-integration.vue?vue&type=template&id=6f478494&scoped=true"
import script from "./_manage-system-integration.vue?vue&type=script&lang=js"
export * from "./_manage-system-integration.vue?vue&type=script&lang=js"
import style0 from "./_manage-system-integration.vue?vue&type=style&index=0&id=6f478494&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f478494",
  null
  
)

export default component.exports